module.exports = __webpack_public_path__ + "static/media/Logo.a4626f40.png";